var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAwaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.954,
    height: 20.907,
    viewBox: "0 0 13.954 20.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f8f7f8;}.b{fill:#dedede;}.c{fill:#ffc942;}.d{fill:#efedee;}.e{fill:#d6d1d6;}.f{fill:#c7c0c7;}.g{fill:#72bbff;}.h{fill:#3d9ef9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-233.001 -313.199)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(233.001 313.199)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.577 2.761)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M106.429,79.48a5.3,5.3,0,0,0-3.08-4.81l-.14-.065a.129.129,0,0,1,0-.234l.14-.065a5.3,5.3,0,0,0,3.08-4.81V65.713H96.464V69.5a5.3,5.3,0,0,0,3.08,4.81l.14.065a.129.129,0,0,1,0,.234l-.14.065a5.3,5.3,0,0,0-3.08,4.81v3.752h9.965Z",
    transform: "translate(-96.464 -65.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.429,66.114v-.4H96.464V69.5a5.3,5.3,0,0,0,3.08,4.81l.124.057a.137.137,0,0,1,0,.249l-.124.057a5.3,5.3,0,0,0-3.08,4.809v3.752h9.965V81.424H98.546a.893.893,0,0,1-.893-.893v-.648a5.3,5.3,0,0,1,3.08-4.81.283.283,0,0,0,.073-.466c-.861-.784-3.152-3.028-3.152-4.707V66.114Z",
    transform: "translate(-96.464 -65.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M141.236,304.694a3.709,3.709,0,0,0-2.151-3.359l-1.075-.5a.381.381,0,0,0-.319,0l-1.075.5a3.7,3.7,0,0,0-2.151,3.359v3.752h6.772Z",
    transform: "translate(-132.867 -290.927)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M141.236,436.316H134.95a.888.888,0,0,1-.486-.144v1.954h6.772Z",
    transform: "translate(-132.867 -420.607)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M236.656,65.713h-4.2a4.255,4.255,0,0,0,4.084,4.9,5.3,5.3,0,0,0,.12-1.118Z",
    transform: "translate(-226.691 -65.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M141.236,78.643A3.7,3.7,0,0,1,139.084,82L138,82.5a.364.364,0,0,1-.3,0l-1.082-.5a3.709,3.709,0,0,1-2.151-3.359V75.26h6.772Z",
    transform: "translate(-132.867 -74.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M232.4,75.511a4.259,4.259,0,0,0,2.574,3.907,3.673,3.673,0,0,0,.083-.774V75.26h-2.648C232.406,75.343,232.4,75.426,232.4,75.511Z",
    transform: "translate(-226.691 -74.859)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M93.233,461.2H83.31a.577.577,0,0,1-.577-.577v-.442a.577.577,0,0,1,.577-.577h9.923a.577.577,0,0,1,.577.577v.442A.577.577,0,0,1,93.233,461.2Z",
    transform: "translate(-82.733 -440.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M93.254,469.814H83.331a.577.577,0,0,1-.573-.509.577.577,0,0,0-.025.169v.442a.577.577,0,0,0,.577.577h9.923a.577.577,0,0,0,.577-.577v-.442a.575.575,0,0,0,0-.068A.577.577,0,0,1,93.254,469.814Z",
    transform: "translate(-82.733 -449.587)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M93.233,53.177H83.31a.577.577,0,0,1-.577-.577v-.442a.577.577,0,0,1,.577-.577h9.923a.577.577,0,0,1,.577.577V52.6A.577.577,0,0,1,93.233,53.177Z",
    transform: "translate(-82.733 -49.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M236.615,51.581H232.59a4.239,4.239,0,0,0-.186,1.246c0,.118.005.235.015.35h4.2a.577.577,0,0,0,.577-.577v-.442A.577.577,0,0,0,236.615,51.581Z",
    transform: "translate(-226.115 -49.414)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.413,
    cy: 3.413,
    r: 3.413,
    transform: "translate(7.129 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M253.861,3.108a3.414,3.414,0,0,1,2-3.108h-.046a3.413,3.413,0,1,0,1.413,6.52A3.414,3.414,0,0,1,253.861,3.108Z",
    transform: "translate(-245.274 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.227 1.386)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M327.653,36.548a.314.314,0,0,1-.223-.092l-1.167-1.167a.458.458,0,0,1-.135-.326V33.312a.315.315,0,0,1,.63,0v1.581l1.118,1.118a.315.315,0,0,1-.223.538Z",
    transform: "translate(-326.128 -32.997)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAwaiting);
export default __webpack_public_path__ + "static/media/ICO_Awaiting.addab5df13a8c432ece4a055240aa8ac.svg";
export { ForwardRef as ReactComponent };